<template>
    <div class="row" :style="{'--text-transform': $store.getters.getTextTransform, '--survey-panel-border-color': $store.getters.getSurveyPanelBorderColor}">
        <div class="col-lg-12">
            <div style="display:none;" class="panel panel-default country-select-panel" id="survey-panel">
                <div class="panel-body">
                    <spinner></spinner>
                    <div v-if="$store.getters.getAccessToken" class="col-lg-12">
                        <div class="col-lg-offset-9 col-lg-3">
                            <button v-on:click="returnToCabinet()" type="button"
                                    class="btn btn-primary btn-lg"
                                    v-bind:style="{ background: buttonBackground}">
                                {{ $t("ui.returnButton") }}
                            </button>
                        </div>
                    </div>
                    <form id="survey-form">
                        <div v-for="block in blocks" class="col-md-12" v-bind:key="block.uid">
                            <div v-bind:class="{ active_block: block.active }">
                                <transition name="fade">
                                    <block @checkRequired="changeFill"
                                           @checkDependency="checkDependency"
                                           v-show="block.active" :model="block" :replaces="replaces"></block>
                                </transition>
                            </div>
                        </div>
                    </form>
                    <div style="margin:10px 10px 10px 10px;" id="submit-button-container">
                        <button :enabled="isSubmitAllowed()" v-on:click="nextBlock()"
                                v-if="blocks.length > 1 && !lastBlock()" type="button"
                                class="btn btn-primary btn-lg ripple" style="font-weight:bold;"
                                v-bind:style="{ background: buttonBackground, color:$store.getters.getButtonTextColor}"
                        >
                            {{ $t("ui.nextButton") }}
                        </button>
                        <button :enabled="isSubmitAllowed()" v-on:click="finish()" v-if="lastBlock()" type="button"
                                class="btn btn-primary btn-lg ripple" style="font-weight:bold;"
                                v-bind:style="{ background: buttonBackground, color:$store.getters.getButtonTextColor}">
                            {{ $t("ui.finishButton") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import Block from '../ui/Block'
    import Spinner from '../ui/Spinner'

    export default {
        name: 'index',
        data() {
            return {
                blocks: [],
                uid: '',
                buttonBackground: '',
                stopFn: false,
                recording: [],
                replaces: []
            }
        },
        mounted() {

            this.uid = this.$route.params.uid;

            let loader = this.$loading.show({
                // Optional parameters
                container: this.fullPage,
                onCancel: this.onCancel
            });

            this.$store.dispatch('QUESTIONNAIRE_DETAIL', this.uid).then(() => {
                this.getQuestionnaireDetail();
                loader.hide();
                document.getElementById('survey-panel').style.display = '';
            }).catch((err) => {
                loader.hide();
                if (err.response.status === 404) {
                    this.$_error('NotFound');
                } else if (err.response.status === 403) {
                    this.$_error('AccessDenied');
                } else {
                    this.$swal({
                        title: 'Error',
                        text: 'The server is temporaryThe server is temporary down down',
                        icon: 'error',
                        confirmButtonColor: this.$store.getters.getButtonColor,
                        confirmButtonText: 'Retry'
                    }).then(() => {
                        window.location.reload();
                    });
                }
            });

            // buttons color
            this.buttonBackground = this.$store.getters.getButtonColor;

            /*this.stopFn = record({
                emit: (event) => {
                    this.recording.push(event);
                }
            });*/

        },
        methods: {
            getQuestionnaireDetail: function () {
                this.blocks = this.$store.getters.questionnaireDetail;
                this.replaces = this.$store.getters.getSurveyReplaces;
            },
            nextBlock() {
                this.$store.dispatch('RUN_VALIDATE');
                if (this.$store.getters.isSubmitAllowed) {
                    this.$store.dispatch('NEXT_BLOCK');
                }
            },
            lastBlock() {
                return this.$store.getters.lastBlock;
            },
            showLoader() {
                return this.$store.getters.isLoader;
            },
            changeFill(event) {
                this.$store.dispatch('SET_QUESTION_FILLED', event);
            },
            validateRequired(event) {
                this.$store.dispatch('VALIDATE_REQUIRED', event);
            },
            async finish() {
                this.$store.dispatch('RUN_VALIDATE');
                if (this.$store.getters.isSubmitAllowed) {

                    let loader = this.$loading.show({
                        // Optional parameters
                        fullPage: true,
                        onCancel: this.onCancel
                    });

                    // Wait for Vue to flush the pending re-render so the radio/star/
                    // nps/etc. inputs reflect the latest selection in the DOM before
                    // FormData reads them.
                    await this.$nextTick();

                    let formData = new FormData(document.getElementById('survey-form'));

                    // Source of truth for single-choice answers is the reactive store,
                    // not the DOM. This removes the race where FormData is built before
                    // the hidden radio inputs reflect the user's last click.
                    this.appendSelectedAnswers(formData);

                    formData.append('token', this.$store.getters.getAccessToken);
                    formData.append('survey_acl_uid', this.uid);


                    // next add only allowed params to submit
                    let queryParams = this.getQueryParams(window.location.href);
                    let allowedParams = this.$store.getters.getAdditionalGetParams;
                    allowedParams.forEach((item) => {
                        if (queryParams[item]) {
                            formData.append('query_param_' + item, queryParams[item]);
                        }
                    });

                    //let events_data = JSON.stringify(this.recording);
                    //let events_base64 = Buffer.from(events_data).toString("base64");
                    //formData.append('recorded_events', events_base64);

                    this.$store.dispatch('SUBMIT_SURVEY', formData).then(() => {
                        loader.hide();
                        this.$router.replace({name: 'Finish', params: {uid: this.uid}})
                    }).catch(() => {
                        loader.hide();
                        this.$swal({
                            title: this.$i18n.t('ui.error'),
                            text: this.$i18n.t('ui.errorSendingResult'),
                            icon: 'error',
                            confirmButtonColor: this.$store.getters.getButtonColor,
                            confirmButtonText: this.$i18n.t('ui.close')
                        });
                    })
                }
            },
            appendSelectedAnswers(formData) {
                // Question types whose value is carried by a hidden/display:none input
                // and is therefore vulnerable to the Vue re-render race.
                const singleChoiceTypes = [
                    'radio', 'custom_radio_icon', 'select',
                    'star', 'heart', 'nps', 'plus', 'pepper', 'fire', 'ice_cream'
                ];

                this.$store.getters.questionnaireDetail.forEach((block) => {
                    if (!block.active) {
                        return;
                    }
                    block.questions.forEach((question) => {
                        if (singleChoiceTypes.indexOf(question.type) === -1) {
                            return;
                        }
                        // Re-set the question key from the reactive selected answer,
                        // overriding whatever (possibly stale) value FormData picked up.
                        formData.delete(question.uid);
                        const selected = (question.answers || []).find((answer) => answer.selected);
                        if (selected) {
                            formData.append(question.uid, selected.uid);
                        }
                    });
                });
            },
            isSubmitAllowed() {
                return this.$store.getters.isSubmitAllowed;
            },
            getQueryParams: function (url) {
                var pos = url.indexOf('?');
                if (pos < 0) {
                    return {};
                }

                var pairs = this.grep(url.substring(pos + 1).split('#')[0].split('&'), function (value) {
                    return value !== '';
                });
                var params = {};

                for (var i = 0, len = pairs.length; i < len; i++) {
                    var pair = pairs[i].split('=');
                    var name = decodeURIComponent(pair[0].replace(/\+/g, '%20'));
                    var value = decodeURIComponent(pair[1].replace(/\+/g, '%20'));
                    if (!name.length) {
                        continue;
                    }
                    if (params[name] === undefined) {
                        params[name] = value || '';
                    } else {
                        if (!this.isArray(params[name])) {
                            params[name] = [params[name]];
                        }
                        params[name].push(value || '');
                    }
                }
                return params;
            },
            grep: function (a, b, c) {
                for (var d, e = [], f = 0, g = a.length, h = !c; f < g; f++) d = !b(a[f], f), d !== h && e.push(a[f]);
                return e
            },
            isArray(Array) {
                return Array.isArray
            },
            checkDependency: function () {
                this.blocks.forEach((blockItem) => {
                    let questions = blockItem.questions;
                    questions.forEach((questionItem) => {
                        this.dependParentRecursive(questionItem);
                    });
                });
            },
            /*dependParentRecursive: function (parentQuestionItem) {
                let child = parentQuestionItem.child;
                let childQuestionsUid = [];
                child.forEach((childItem) => {
                    childQuestionsUid.push(childItem.child_question_uid);

                });
                let parentAnswers = parentQuestionItem.answers;
                let parentQuestionSelectedCount = 0;
                child.forEach((childItem) => {
                    parentAnswers.forEach((parentAnswerItem) => {
                        if (parentAnswerItem.selected && childItem.answer_uid === parentAnswerItem.uid) {
                            parentQuestionSelectedCount = parentQuestionSelectedCount + 1;
                        }
                    });
                });
                this.blocks.forEach((blockItem) => {
                    let questions = blockItem.questions;
                    questions.forEach((questionItem) => {
                        if (childQuestionsUid.indexOf(questionItem.uid) >= 0) {
                            if (parentQuestionSelectedCount > 0) {
                                questionItem.hide_by_depend = false;
                            } else {
                                questionItem.hide_by_depend = true;
                                questionItem.answers.forEach((answerChild) => {
                                    answerChild.selected = false;
                                });
                                this.dependParentRecursive(questionItem);
                            }
                        }
                    });
                });
            },*/
            dependParentRecursive: function (parentQuestionItem) {
                let child = parentQuestionItem.child;
                child.forEach((childItem) => {
                    this.blocks.forEach((blockItem) => {
                        let questions = blockItem.questions;
                        questions.forEach((childQuestionItem) => {
                            if (childQuestionItem.uid === childItem.child_question_uid) {
                                let answers = parentQuestionItem.answers;
                                // selected answers
                                let selectedAnswers = [];
                                answers.forEach((answerItem) => {
                                    if (answerItem.selected) {
                                        selectedAnswers.push(answerItem['uid'])
                                    }
                                });
                                if (selectedAnswers.indexOf(childItem.answer_uid) >= 0) {
                                    childQuestionItem.hide_by_depend = false;
                                } else {
                                    childQuestionItem.hide_by_depend = true;
                                    childQuestionItem.answers.forEach((answerChild) => {
                                        answerChild.selected = false;
                                    });
                                }
                                this.dependParentRecursive(childQuestionItem);
                            }
                        })
                    })
                })
            },
            returnToCabinet: function () {
                this.$router.push({name: 'Cabinet'});
            },
            callback() {

            }
        },
        components: {
            Block,
            Spinner
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.25s ease-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
